module.exports = __webpack_public_path__ + "static/media/joeseph-taylor.9b140e6e.jpg";